import { Button } from "@/shared/ui/button.tsx";
import { Separator } from "@/shared/ui/separator.tsx";
import CalibrationForm from "./calibration/CalibrationForm";

const SettingsView = () => {
  return <div className="mt-[5vh] w-full h-[95vh] p-5 md:p-10 2xl:p-14 overflow-auto flex flex-col gap-4 xl:gap-8">
    <h1 className="text-2xl animate-in slide-in-from-left-32 fade-in ease-in duration-1000 md:text-5xl font-header font-medium">Personalize your AI</h1>
    <section className="w-full flex items-start border border-gray-300 shadow-md p-4 rounded-xl">
      <div className="w-1/4 h-full px-3">
        <Button variant="secondary" className="flex-1 w-full">Calibration Settings</Button>
      </div>
      <Separator orientation="vertical" />
      <div className="flex-1 px-3">
        <CalibrationForm />
      </div>
    </section>
  </div>;
};

export default SettingsView;

